import React from "react";
import { Toolbar, useMediaQuery, styled } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import MuiAppBar from "@mui/material/AppBar";
import { SidebarWidth } from "../../config/SidebarConfig";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import logoImg from "../../assets/images/ZingAuditorFullLogo.svg";
import logoImgForMobile from "../../assets/images/ZingAuditorSymbol.svg";
import { Icons } from "../../config/MuiIcons.config";
import { Link } from "react-router-dom";
import { showUnauthorizedUserMessage } from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import UnAuthorizedUserPopup from "../UnauthrizedUserPopup/UnauthorizedUserPopup";

const drawerWidth = SidebarWidth;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const useStyles = makeStyles((theme) => ({
  deskTopLogo: {
    height: 30, // Adjust the height according to your need
    // marginRight: theme.spacing(2),
  },
  mobileLogo: {
    height: 40, // Adjust the height according to your need
    // marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
  },
}));

const Header = ({ IsSideBarOpen, HandleSideBarOpen }) => {
  const open = IsSideBarOpen;
  const classes = useStyles({ open });
  let isMobileMid = useMediaQuery("(max-width:500px)");
  const dispatch = useDispatch();
  const isUserHaveUnathorizedAccess = useSelector(
    (state) => state.UnauthorizedUserReducer.isUserHaveUnathorizedAccess
  );

  // Funtion to handle popup toggle
  const toggleFunction = () => {
    dispatch(showUnauthorizedUserMessage(false));
  };

  return (
    <React.Fragment>
      {isUserHaveUnathorizedAccess && (
        <UnAuthorizedUserPopup
          ModalState={isUserHaveUnathorizedAccess}
          ToggleFunction={toggleFunction}
        />
      )}
      <AppBar position="fixed" open={open} color="inherit">
        <Toolbar className="d-flex align-items-center justify-content-between">
          <div>
            <Link to="/">
              {isMobileMid ? (
                <img
                  src={logoImgForMobile}
                  alt="Zingworks Logo"
                  className={classes.mobileLogo}
                />
              ) : (
                <img
                  src={logoImg}
                  alt="Zingworks Logo"
                  className={classes.deskTopLogo}
                />
              )}
            </Link>
            <IconButton onClick={HandleSideBarOpen}>
              <Icons.MenuIcon
                style={{
                  cursor: "pointer",
                }}
                color="action"
              />
            </IconButton>
          </div>

          {/* Profile Menu Component */}
          <ProfileMenu />
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default Header;
